import uploadImage from './uploadImage';
import uploadFile from './uploadFile';
import uploadImageMulti from './uploadFileMulti';
import uploadResource from './uploadResource';
import removeResource from './removeResource';

export default {
  uploadImage,
  uploadImageMulti,
  uploadFile,
  uploadResource,
  removeResource,
};



// WEBPACK FOOTER //
// ./src/app/services/file/index.js